import * as React from "react";
import type { SVGProps } from "react";
const SvgStarActive = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="#currentColor"
            fillRule="evenodd"
            d="M12.91 4.582a1 1 0 0 0-1.818 0l-2.018 4.39-4.798.563a1 1 0 0 0-.562 1.728l3.551 3.276-.947 4.737a1 1 0 0 0 1.47 1.068L12 17.98l4.212 2.365a1 1 0 0 0 1.47-1.068l-.947-4.737 3.551-3.276a1 1 0 0 0-.561-1.728l-4.799-.563z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgStarActive;
